import { FC, useState, useEffect } from 'react';
import { useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { getCourses, Course } from '../services/university-service';
import CourseGrid from '../components/university/CourseGrid';
import { useTranslation } from 'react-i18next';

const Courses: FC = () => {
  const [courses, setCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    loadCourses();
  }, []);

  const loadCourses = async () => {
    try {
      setLoading(true);
      const response = await getCourses();
      if (response.statusCode === 200) {
        setCourses(response.message || []);
      } else {
        toast({
          title: t('university.courses.error_loading_courses'),
          description: response.message || t('general.error'),
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error: any) {
      toast({
        title: t('university.courses.error_loading_courses'),
        description: error.message || t('general.error'),
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCourseClick = (course: Course) => {
    navigate(`/university/courses/${course.id}`);
  };

  return (
    <CourseGrid
      courses={courses}
      onCourseClick={handleCourseClick}
      loading={loading}
      columns={{ base: 1, md: 2, lg: 3 }}
      title={t('university.courses.available_courses')}
      spacing={6}
    />
  );
};

export default Courses; 